/**
 * Custom Paragraph extension for TipTap.
 * Adds nodeId attribute.
 */

import Paragraph from "@tiptap/extension-paragraph";

const CustomParagraph = Paragraph.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      nodeId: {
        default: null,
        parseHTML: (element: HTMLElement) => element.getAttribute("data-node-id"),
        renderHTML: (attributes: Record<string, unknown>) => {
          if (!attributes.nodeId) return {};
          return { "data-node-id": attributes.nodeId };
        },
      },
    };
  },
});

export default CustomParagraph;
